const transformCase = (caseSensitive, text) => {
  if (caseSensitive) {
    return text;
  }
  return text.toLowerCase();
};

/**
 * Search the array of items for a specific string query.
 *
 * Sources:
 * - https://stackoverflow.com/a/36508315/8315965
 * @param {Array.<*>} array
 * @param {string} query
 * @param {object} [opts]
 * @param {boolean} [opts.caseSensitive] Use the case sensitive search to match the query.
 * @param {Function} [opts.stringifyItem] Transforms array item into its string representation.
 * Default implementation uses `String(val)` to get the string, so it should be compatible
 * with searching in arrays of primitive values.
 * To search the array of objects it's necessary to supply this function.
 * @returns {Array.<*>} Array of items that matched the query.
 */
const search = (
  array,
  query,
  { caseSensitive = false, stringifyItem = item => String(item) } = {},
) => {
  const transformedQuery = transformCase(caseSensitive, query);
  const queryWords = transformedQuery.match(/\b(\w+)\b/g);
  if (queryWords == null) {
    return array;
  }
  return array.filter(item => {
    const itemString = stringifyItem(item);
    const transformedItemString = transformCase(caseSensitive, itemString);
    return queryWords.every(word => transformedItemString.includes(word));
  });
};

export default search;
